import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src

@Component
export default class SidenaviLine extends Vue {
  private　name = 'SidenaviLine';
}
